import { DirectoryAddress } from "../Models/DirectoryAddress";

class DirectorySearchHelper {
    public static formatPhoneNumbers(phoneNumbers: string[]): string {
        return phoneNumbers?.any()
            ? `T: ${phoneNumbers?.map(phone => phone)
                .filter(p => !IsNullOrWhiteSpace(p))
                .join(", ") ?? ""} `
            : "";
    }

    public static formatComponentPhoneNumbers(phoneNumbers: JSX.Element[]): JSX.Element {
        return phoneNumbers?.any()
            ? (
                <>T: {phoneNumbers?.map(phone => phone)
                    .filter(p => p != null)
                    .reduce((prev, curr) => <>{prev}, {curr}</>, <></>) ?? <></>
                }
                </>
            )
            : <></>;
    }

    public static formatFaxNumbers(faxNumbers: string[]): string {
        return faxNumbers?.any()
            ? ` F: ${faxNumbers?.map(fax => fax)
                .filter(p => !IsNullOrWhiteSpace(p))
                .join(", ") ?? ""} `
            : "";
    }

    public static formatAddress(address: DirectoryAddress): string {
        const countryCode = cacheStore.StateCacheById[address.stateId]?.SubdivisionCode?.split("-")?.[1];
        return [address?.streetAddress, address?.city, countryCode, address?.postalCode]
            .filter(p => !IsNullOrWhiteSpace(p))
            .join(" ");
    }
}

export { DirectorySearchHelper };
